import styles from './RubricTreemap.module.scss';

export const Glyph = (
  <svg viewBox="0 0 32 32" className={`chart-glyph ${styles.glyph}`}>
    <rect
      x="2"
      y="2"
      width="13"
      height="28"
      className={styles['glyph-box1']}
      rx={2}
    />
    <rect
      x="17"
      y="2"
      width="13"
      height="10"
      className={styles['glyph-box2']}
      rx={2}
    />
    <rect
      x="17"
      y="14"
      width="13"
      height="16"
      className={styles['glyph-box3']}
      rx={2}
    />
  </svg>
);
